const GetCategoryByName = `
  query GetCategoryByName($category: String) {
    category(where: { category: { _eq: $category} }) {
      uuid
    }
  }
`;

export default GetCategoryByName;
